import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  text: {
    color: Color.simplyWhite,
  },
  bullet: {
    width: 8,
    height: 8,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Color.simplyWhite,
    marginRight: Spacing.S,
    marginBottom: 2,
  },
  bulletError: {
    backgroundColor: Color.soothingPink,
  },
  bulletOk: {
    backgroundColor: Color.refinedGreen,
  },
})

interface Props extends ViewProps {
  value?: string
}

const PasswordHelp = (props: Props) => {
  const { value, style, ...otherProps } = props

  const renderBullet = (status?: boolean) => {
    return <View style={[styles.bullet, status ? styles.bulletOk : styles.bulletError]} />
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.text}>
        <Trans>Create a password that:</Trans>
        {'\n'}
        {renderBullet(!!value && value.length >= 6)}
        <Trans>Has at least 6 characters</Trans>
        {'\n'}
        {renderBullet(!!value && /[a-z]+/.test(value)) && renderBullet(!!value && /[A-Z]+/.test(value))}
        <Trans>Has uppercase and lowercase letters</Trans>
        {'\n'}
        {renderBullet(!!value && /[0-9]+/.test(value))}
        <Trans>Has at least 1 number</Trans>
      </Text>
    </View>
  )
}

export default PasswordHelp
